import { useMemo } from 'react';

function useStableRecord(record) {
  const signature = useMemo(() => {
    if (record == null) return '';
    try {
      return JSON.stringify(record);
    } catch {
      return String(record);
    }
  }, [record]);

  return useMemo(() => record, [signature]);
}

/**
 * Normalizes detail-page fetch state from a Redux detail slice.
 */
export function useDetailPageState({
  routeId,
  detailRecord,
  hasUiFallback = false,
  fallbackData = null,
}) {
  const rawData = detailRecord?.data ?? fallbackData ?? null;
  const data = useStableRecord(rawData);
  const hasError = Boolean(routeId) && !hasUiFallback && Boolean(detailRecord?.hasError);
  const isLoading =
    Boolean(routeId) && !hasUiFallback && !hasError && (Boolean(detailRecord?.isLoading) || !data);

  return { data, isLoading, hasError };
}

export function useEntityDetailPageState({
  entityId,
  entityData,
  isLoading = false,
  hasError = false,
  hasUiFallback = false,
}) {
  const data = useStableRecord(entityData ?? null);
  const resolvedHasError = Boolean(entityId) && !hasUiFallback && Boolean(hasError);
  const resolvedIsLoading =
    Boolean(entityId) && !hasUiFallback && !resolvedHasError && (Boolean(isLoading) || !data);

  return {
    data,
    isLoading: resolvedIsLoading,
    hasError: resolvedHasError,
  };
}
